import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { ATTRIBUTE_FRAGMENT } from './fragments/attribute'
import { GENERAL_FRAGMENT } from './fragments/general'
import { PREBID_STACK_FRAGMENT } from './fragments/prebidStack'
import { REFRESHER_FRAGMENT } from './fragments/refresher'
import { UNFILLED_RECOVERY_FRAGMENT } from './fragments/unfilledRecovery'
import { VIEWABILITY_TOOLS_FRAGMENT } from './fragments/viewabilityTools'

import type { Data } from './types'

export const GET_AB_TEST_VARIANTS_SCHEMA: TypedDocumentNode<Data> = gql`
  ${ATTRIBUTE_FRAGMENT}
  ${GENERAL_FRAGMENT}
  ${PREBID_STACK_FRAGMENT}
  ${REFRESHER_FRAGMENT}
  ${UNFILLED_RECOVERY_FRAGMENT}
  ${VIEWABILITY_TOOLS_FRAGMENT}

  query abTestVariantsSchema($domainId: ID!) {
    abTestVariantsSchema(domainId: $domainId) {
      general {
        ...abTestsVariantsGeneralFragment
      }
      prebidStack {
        ...abTestsVariantsPrebidStackFragment
      }
      refresher {
        ...abTestsVariantsRefresherFragment
      }
      reportedKeyValue {
        ...abTestsVariantsAttributesFragment
      }
      trafficShare {
        ...abTestsVariantsAttributesFragment
      }
      unfilledRecovery {
        ...abTestsVariantsUnfilledRecoveryFragment
      }
      viewabilityTools {
        ...abTestsVariantsViewabilityToolsFragment
      }
    }
  }
`
